import { Button } from '@/components/ui/button';
import { SheetContextProvider } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/SheetContext';
import { BenachrichtigungenDesktop } from '@/domain/navigation/benachrichtigungen/components/desktop/BenachrichtigungenDesktop';
import BenachrichtungenMobile from '@/domain/navigation/benachrichtigungen/components/mobile/BenachrichtigungenMobile';
import { useBenachrichtigungen } from '@/domain/navigation/benachrichtigungen/hooks/useBenachrichtigungen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';

export function BenachrichtigungenItem() {
  return (
    <Suspense
      fallback={
        <Button variant="ghost" size="icon" disabled>
          <FontAwesomeIcon icon={faSpinner} spin />
        </Button>
      }>
      <BenachrichtungenSuspense />
    </Suspense>
  );
}

export function BenachrichtungenSuspense() {
  const standort = useStandortContext();
  const b = useBenachrichtigungen(standort.currentStandort.id);

  return (
    <div>
      <span className="hidden md:block">
        <SheetContextProvider>
          <BenachrichtigungenDesktop benachrichtigungen={b} />
        </SheetContextProvider>
      </span>
      <span className="md:hidden">
        <BenachrichtungenMobile benachrichtigungen={b} />
      </span>
    </div>
  );
}
